import {
  AppStorageKeys,
  DefaultServiceProvider,
} from "../../Constants/Constants";
import SessionStorage from "../../Constants/SessionStorage";
const axios = require("axios");
const qs = require("qs");

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);

const PARTNER = ENV_VARS_FE.PARTNER || DefaultServiceProvider;
const CLIENT_ID = ENV_VARS_FE.CLIENT_ID;
const CLIENT_SECRET = ENV_VARS_FE.CLIENT_SECRET[PARTNER];

const AUTH_URL = ENV_VARS_FE.AUTH_URL;
const AUTH_PORT = ENV_VARS_FE.AUTH_PORT;
const AUTH_PATH_PREFIX = ENV_VARS_FE.AUTH_PATH_PREFIX ?? "/auth";
const AUTH_API_PATH = `${AUTH_PATH_PREFIX}/realms/${PARTNER}/protocol/openid-connect/token`;

const MaskedSecret = CLIENT_SECRET?.slice(0, 10) + "**********";

async function login(authUrl, username, password) {
  console.log("auth envs:", AUTH_URL, AUTH_PORT);
  console.log("client envs:", PARTNER, CLIENT_ID, MaskedSecret);
  const authURL = AUTH_URL || authUrl;
  const data = qs.stringify({
    grant_type: "password",
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    username: username,
    password: password,
  });
  const config = {
    method: "post",
    url: authURL + ":" + AUTH_PORT + AUTH_API_PATH,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: data,
  };

  const response = {
    code: 500,
    status: "Failure",
    message: "error authenticating user!",
  };
  try {
    const loginRes = await axios(config);
    console.log("login response:", loginRes);
    const userData = loginRes?.data;
    if (userData) {
      console.log("login success:", userData);
      response.code = 200;
      response.status = "Success";
      response.message = userData;
    }
  } catch (error) {
    console.log("login failed:", error);
    if (error.response && error.response.status === 401) {
      response.code = 401;
      response.message = "Invalid credentials!";
    }
  }
  return response;
}

export const AuthService = {
  login,
};
